import { useSearchParams } from "react-router-dom";
import { useTranslationShowQuery } from "@/admin/entities/translations";
import {
  getColumnsConfig,
  getMobileColumnsConfig,
  getTextsConfig,
} from "./config";
import type { TranslationCellComponents } from "./config";
import { getTableData, mapColumns } from "./mappers";

export function useTranslationsManagement(
  cellComponents: TranslationCellComponents
) {
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");

  useTranslationShowQuery(id, id === null);

  return {
    columns: getColumnsConfig(cellComponents),
    mobileColumns: getMobileColumnsConfig(cellComponents),
    mapColumns,
    getTableData,
    texts: getTextsConfig(),
  };
}
